import { Navigation } from 'src/app/@theme/types/navigation';

export const menus: Navigation[] = [
    {
        id: 'dash',
        title: 'Dashboard',
        type: 'item',
        classes: 'nav-item',
        url: 'dash',
        icon: '#custom-status-up',
    },{
        id: 'calendar',
        title: 'Calendar',
        type: 'item',
        classes: 'nav-item',
        url: 'calendar',
        icon: '#custom-calendar-1'
    },
    {
        id: 'bookings',
        title: 'Bookings',
        type: 'item',
        classes: 'nav-item',
        url: 'bookings',
        icon: '#custom-text-align-justify-center'
    },
    {
        id: 'invoices',
        title: 'Invoices',
        type: 'item',
        classes: 'nav-item',
        badge: { title: '' },
        url: 'invoices',
        icon: '#custom-dollar-square'
    },
    {
        id: 'requests',
        title: 'Requests',
        type: 'item',
        classes: 'nav-item',
        badge: { title: '' },
        url: 'requests',
        icon: '#custom-flag'
    },
    {
        id: 'guests',
        title: 'Guests',
        type: 'item',
        classes: 'nav-item',
        url: 'guests',
        icon: '#custom-user-square'
    },
    {
        id: 'other',
        title: '',
        type: 'group',
        children: [
            {
                id: 'settings',
                title: 'Settings',
                type: 'collapse',
                children: [
                    {
                        id: 'objects',
                        title: 'Objects',
                        type: 'item',
                        classes: 'nav-item',
                        url: 'objects'
                    },
                    {
                        id: 'administrators',
                        title: 'Administrators',
                        type: 'item',
                        classes: 'nav-item',
                        url: 'administrators'
                    },
                    {
                        id: 'workers',
                        title: 'Workers',
                        type: 'item',
                        classes: 'nav-item',
                        url: 'workers'
                    },
                    {
                        id: 'rooms',
                        title: 'Rooms',
                        type: 'item',
                        classes: 'nav-item',
                        url: `rooms/${localStorage.getItem('objectId')}`
                    },
                    {
                        id: 'bed types',
                        title: 'Bed types',
                        type: 'item',
                        classes: 'nav-item',
                        url: 'bedtypes'
                    },
                    {
                        id: 'information',
                        title: 'Information',
                        type: 'item',
                        classes: 'nav-item',
                        url: 'information'
                    }
                ]
            }
        ]
    }
];
